/**
 *
 * @param {*} serviceRequest is a function promise: () => service(arg1, arg2, ...)
 * @param {Integer} attempts number of service call retries
 * @returns response data
 */
export const retryService = async (serviceRequest, attempts = 2, condition = (res) => { return res; }, errorCondition = () => { return true; }) => {
    return await serviceRequest()
        .then((res) => condition(res))
        .catch(error => {
            if (attempts > 1 && errorCondition(error)) {
                return retryService(serviceRequest, attempts - 1);
            }
            // if the attempts are over we return the error
            throw error;
        });
};
/**
 - Caso 1 fallan todos
    id request intentos
    1  {} 3  retornar createLoan(falló -> catch 3 > 1 verdadero retornar
        2 {} 2 retornar createLoan(falló -> catch 2 > 1 verdadero retornar
            3 {} 1 retornar createLoan(falló -> catch 1 > 1 false retornar Error)))

 - Caso 2 fallan los primeros dos
    id request intentos
    1  {} 3  retornar createLoan(falló -> catch 3 > 1 verdadero retornar
        2 {} 2 retornar createLoan(falló -> catch 2 > 1 verdadero retornar
            3 {} 1 retornar createLoan ok response data))
 */
